/** author: 胡枭 */

import request from '@/utils/request.js'

const baseUrl = process.env.VUE_APP_PURCHASE_API
const companyUrl = process.env.VUE_APP_COMPANY_API

// 国密-校验用户手机号
export function getVerifyPhoneApi(data) {
  return request({
    url: `${companyUrl}/users/mobile-validation`,
    method: 'post',
    data
  })
}

// 国密-校验用户权限
export function getVerifyUserAuthApi(data) {
  return request({
    url: `${companyUrl}/enterprise/employees/role-validation`,
    method: 'post',
    data
  })
}

// 国密-招标采购数据篡改校验
export function getCryptoValidationApi(data, params) {
  return request({
    url: `${baseUrl}/crypto-openness/validation`,
    method: 'post',
    data,
    params
  })
}
